<micro-select-combo #sel
                    [placeholder]="placeholder"
                    valueField="label"
                    [(id)]="id"
                    (idChange)="change($event)"
                    [options]="options"
                    [required]="required"
                    [disabled]="disabled"
                    [requires]="requires()"
                    [jump]="jump"
                    [searchable] = "searchable"
>
</micro-select-combo>
